import React, { FC } from 'react';
import styles from './PasswordIndicator.module.scss';

interface PasswordIndicatorProps {
	fair?: boolean;
	strong?: boolean;
}

const PasswordIndicator: FC<PasswordIndicatorProps> = ({ fair, strong }) => {
	const isWeak = !fair && !strong;
	const isFair = fair && !strong;

	return (
		<section className={styles.PasswordIndicator}>
			<section className={styles.Indicator}>
				<span className={`${styles.Line} ${styles.Red}`}></span>
				<span className={`${styles.Line} ${styles.Orange} ${fair ? styles.Active : ''}`}></span>
				<span className={`${styles.Line} ${styles.Green} ${strong ? styles.Active : ''}`}></span>
			</section>
			<p>
				Your password is
				<span className={`${styles.Type} ${isFair ? styles.Orange : ''} ${!isWeak && !isFair ? styles.Green : ''}`}>
					{isWeak && 'Weak'}
					{isFair && 'Fair'}
					{!isWeak && !isFair && 'Strong'}
				</span>
			</p>
		</section>
	);
};

export { PasswordIndicator };
